@for (p of pieces(); track i; let i = $index) {
  <div class="tile {{ color(i) }}"
       [class.from]="getCoord(white() ? i : 63 - i) === from()"
       [class.move]="moves().includes(getCoord(white() ? i : 63 - i))"
       [class.last-move]="getCoord(white() ? i : 63 - i) === lastMoveTo()"
       (click)="clickSquare(white() ? i : 63 - i)"
       cdkDropList
       [cdkDropListData]="white() ? i : 63 - i"
       (cdkDropListDropped)="drop($any($event))">
    @if (white() ? p : pieces()[63-i]; as rp) {
      <div class="chess-piece {{ rp?.color }}"
           [class.translate]="translate().includes(rp.square)"
           [class.disabled]="!writeAccess() || turn() !== rp.color"
           cdkDrag
           cdkDragBoundary=".chess-board"
           (cdkDragStarted)="setPieceSize()"
           [cdkDragData]="rp"
           [cdkDragDisabled]="config.mobile() || turn() !== rp.color">{{ drawPiece(rp) }}</div>
    }
    @if (capturedPiece(); as captured) {
      @if (getCoord(white() ? i : 63 - i) === captured.square) {
        <div class="chess-piece {{ captured.piece.color }} captured">{{ drawPiece(captured.piece) }}</div>
      }
    }
  </div>
}
@if (promotion(); as promotion) {
  <div class="promotion" (click)="cancelPromotion()">
    <div class="promotion-pieces" (click)="$event.stopPropagation()">
      @for (type of promotionPieces; track type) {
        <button type="button"
                class="promotion-piece chess-piece {{ turn() }}"
                (click)="promote(type)">{{ drawPiece({ type, color: turn(), square: promotion.to }) }}</button>
      }
    </div>
  </div>
}
